import { useState } from 'react';
import { ButtonsGroup } from '@hungryroot/pho';
import { type ServingSize } from '@hungryroot/rest';
import { StyledSheetOrModal } from '../StyledSheetOrModal/StyledSheetOrModal';
import styles from './EditRecipeSizeModal.module.css';

interface Props {
  initialValue: ServingSize;
  onSubmit(value: ServingSize): void;
  onCancel(): void;
  isOpen: boolean;
  isSubmitting?: boolean;
  confirmButtonText: string;
}

export function EditRecipeSizeModal({
  initialValue,
  onSubmit,
  isOpen,
  onCancel,
  isSubmitting,
  confirmButtonText,
}: Props) {
  const [value, setValue] = useState(initialValue);
  return (
    <StyledSheetOrModal
      testid="edit-recipe-size"
      onCancel={onCancel}
      onAdd={() => {
        onSubmit(value);
      }}
      bodyText="Choose between 2-serving and 4-serving recipes. You can always add extra recipes or groceries to your delivery."
      heading="Edit recipe size"
      confirmButtonText={confirmButtonText}
      ariaLabel="Edit recipe size"
      isOpen={isOpen}
      isSubmitting={isSubmitting}
    >
      <ButtonsGroup
        buttonClassName={styles['button']}
        className={styles['buttons-group']}
        selected={value}
        options={[
          {
            label: '2 servings',
            value: 2,
          },
          {
            label: '4 servings',
            value: 4,
          },
        ]}
        handleClick={(next: ServingSize) => {
          setValue(next);
        }}
      />
    </StyledSheetOrModal>
  );
}
